export default [{
  path: '/sanction-type/:id',
  name: 'sanctionTypeItem',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/sanctionTypeItem/index')
}]
